import React, { useMemo, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Divider, Grid } from '@mui/material';
import { useMessages } from 'modules/intl';
import { InsightsDateRangeNavigator } from '../components/InsightsDateRangeNavigator';
import { DataScienceAccuracy } from '../components/DataScience';
import {
  NoteInsightsViewOptions,
  useNoteInsightsContext
} from '../Notes/NoteInsightsContextProvider';

const useStyles = makeStyles((theme) => ({
  container: {
    height: theme.spacing(8),
    alignItems: 'center'
  }
}));

const messageIds = [
  'insights.viewOptions.thisMonth',
  'insights.viewOptions.today',
  'insights.viewOptions.thisWeek',
  'insights.viewOptions.lastNinetyDays'
];

const InsightsHeader: React.FC = () => {
  const classes = useStyles();
  const [disableNext, setDisableNext] = useState(false);
  const [disablePrevious, setDisablePrevious] = useState(false);
  const messages = useMessages(messageIds);

  const viewOptions = useMemo(
    () => [
      {
        value: NoteInsightsViewOptions.TODAY,
        text: messages['insights.viewOptions.today']
      },
      {
        value: NoteInsightsViewOptions.THIS_WEEK,
        text: messages['insights.viewOptions.thisWeek']
      },
      {
        value: NoteInsightsViewOptions.THIS_MONTH,
        text: messages['insights.viewOptions.thisMonth']
      },
      {
        value: NoteInsightsViewOptions.LAST_NINETY_DAYS,
        text: messages['insights.viewOptions.lastNinetyDays']
      }
    ],
    [messages]
  );
  const {
    currentPeriod,
    setCurrentPeriod,
    setSelectedViewOption,
    selectedViewOption
  } = useNoteInsightsContext();
  return (
    <>
      <Grid
        container
        className={classes.container}
        data-testid="insights-header"
      >
        <Grid item xs={6} alignItems={'center'}>
          <InsightsDateRangeNavigator
            disablePrevious={disablePrevious}
            setDisablePrevious={setDisablePrevious}
            disableNext={disableNext}
            setDisableNext={setDisableNext}
            viewOptions={viewOptions}
            currentPeriod={currentPeriod}
            setCurrentPeriod={setCurrentPeriod}
            setSelectedViewOption={setSelectedViewOption}
            selectedViewOption={selectedViewOption}
          />
        </Grid>
        <Grid item xs={6}>
          <DataScienceAccuracy />
        </Grid>
      </Grid>
      <Divider />
    </>
  );
};

export default React.memo(InsightsHeader);
